import styles from './index.module.css'

import cn from 'clsx'
import React from 'react'

import { Badge } from '..'

type Props = Omit<React.ComponentProps<typeof Badge>, 'variant'> & {
  variant?: React.ComponentProps<typeof Badge>['variant'] | 'ghost'
}

/**
 * Wrapper around the Badge component from @radix-ui/themes that adds a
 * `ghost` variant: same size, padding and shape as `soft`, but with no
 * background, for badges that need to sit inline with plain text/icons.
 */
const DiscoBadge = ({ variant, className, ...rest }: Props) => {
  const isGhost = variant === 'ghost'

  return (
    <Badge
      {...rest}
      variant={isGhost ? 'soft' : variant}
      className={cn(isGhost && styles.ghost, className)}
    />
  )
}

export default DiscoBadge
